<template>
  <RegPalletComponent goods-type="S0100" />
</template>
<script>
import RegPalletComponent from './RegPalletComponent'
export default {
  name: 'RegProduct',
  components: {
    RegPalletComponent
  },
  data: function () {
    return {
      isLoading: false,
      userInfo: null
    }
  },
  created () {

  },
  mounted () {
  },
  updated () {
  },
  methods: {
  }
}
</script>

<style lang="scss">

</style>
